module.exports = __webpack_public_path__ + "img/Rectangle 257.d0268d37.png";